"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var fp_ts_1 = require("fp-ts");
var exit_1 = require("./original/exit");
var T = __importStar(require("./effect"));
var Do_1 = require("fp-ts-contrib/lib/Do");
var Apply_1 = require("fp-ts/lib/Apply");
var Ar = __importStar(require("fp-ts/lib/Array"));
var Op = __importStar(require("fp-ts/lib/Option"));
var Ei = __importStar(require("fp-ts/lib/Either"));
var TR = __importStar(require("fp-ts/lib/Tree"));
var RE = __importStar(require("fp-ts/lib/Record"));
var ManagedTag;
(function (ManagedTag) {
    ManagedTag[ManagedTag["Pure"] = 0] = "Pure";
    ManagedTag[ManagedTag["Encase"] = 1] = "Encase";
    ManagedTag[ManagedTag["Bracket"] = 2] = "Bracket";
    ManagedTag[ManagedTag["Suspended"] = 3] = "Suspended";
    ManagedTag[ManagedTag["Chain"] = 4] = "Chain";
    ManagedTag[ManagedTag["BracketExit"] = 5] = "BracketExit";
})(ManagedTag = exports.ManagedTag || (exports.ManagedTag = {}));
var toM = function (_) { return _; };
var fromM = function (_) { return _; };
/**
 * Lift a pure value into a resource
 * @param value
 */
function pure(value) {
    return toM(function () { return ({
        _tag: ManagedTag.Pure,
        value: value
    }); });
}
exports.pure = pure;
/**
 * Create a Resource by wrapping an IO producing a value that does not need to be disposed
 *
 * @param res
 * @param f
 */
function encaseEffect(rio) {
    return toM(function (r) { return ({
        _tag: ManagedTag.Encase,
        acquire: T.provide(r)(rio)
    }); });
}
exports.encaseEffect = encaseEffect;
/**
 * Create a resource from an acquisition and release function
 * @param acquire
 * @param release
 */
function bracket(acquire, release) {
    return toM(function (r) { return ({
        _tag: ManagedTag.Bracket,
        acquire: T.provide(r)(acquire),
        release: function (a) { return T.provide(r)(release(a)); }
    }); });
}
exports.bracket = bracket;
function bracketExit(acquire, release) {
    return toM(function (r) { return ({
        _tag: ManagedTag.BracketExit,
        acquire: T.provide(r)(acquire),
        release: function (a, e) { return T.provide(r)(release(a, e)); }
    }); });
}
exports.bracketExit = bracketExit;
/**
 * Lift an IO of a Resource into a resource
 * @param suspended
 */
function suspend(suspended) {
    return toM(function (r) {
        return ({
            _tag: ManagedTag.Suspended,
            suspended: T.effect.map(T.provide(r)(suspended), function (m) { return function (_) { return fromM(m)(r); }; })
        });
    });
}
exports.suspend = suspend;
/**
 * Compose dependent resourcess.
 *
 * The scope of left will enclose the scope of the resource produced by bind
 * @param left
 * @param bind
 */
function chain_(left, bind) {
    return toM(function (r) { return ({
        _tag: ManagedTag.Chain,
        left: provideAll(r)(left),
        bind: function (l) { return provideAll(r)(bind(l)); }
    }); });
}
/**
 * Curried form of chain
 * @param bind
 */
function chain(bind) {
    return function (left) { return chain_(left, bind); };
}
exports.chain = chain;
/**
 * Map a resource
 * @param res
 * @param f
 */
function map_(res, f) {
    return chain_(res, function (r) { return pure(f(r)); });
}
/**
 * Curried form of map
 * @param f
 */
function map(f) {
    return function (res) { return map_(res, f); };
}
exports.map = map;
/**
 * Zip two resources together with the given function.
 *
 * The scope of resa will enclose the scope of resb
 * @param resa
 * @param resb
 * @param f
 */
function zipWith(resa, resb, f) {
    return chain_(resa, function (a) { return map_(resb, function (b) { return f(a, b); }); });
}
exports.zipWith = zipWith;
/**
 * Zip two resources together as a tuple.
 *
 * The scope of resa will enclose the scope of resb
 * @param resa
 * @param resb
 */
function zip(resa, resb) {
    return zipWith(resa, resb, function (a, b) { return [a, b]; });
}
exports.zip = zip;
/**
 * Apply the function produced by resfab to the value produced by resa to produce a new resource.
 * @param resa
 * @param resfab
 */
function ap(resa, resfab) {
    return zipWith(resa, resfab, function (a, f) { return f(a); });
}
exports.ap = ap;
/**
 * Flipped version of ap
 * @param resfab
 * @param resa
 */
function ap_(resfab, resa) {
    return zipWith(resfab, resa, function (f, a) { return f(a); });
}
/**
 * Map a resource to a static value
 *
 * This creates a resource of the provided constant b where the produced A has the same lifetime internally
 * @param fa
 * @param b
 */
function as(fa, b) {
    return map_(fa, fp_ts_1["function"].constant(b));
}
exports.as = as;
/**
 * Curried form of as
 * @param b
 */
function to(b) {
    return function (fa) { return as(fa, b); };
}
exports.to = to;
/**
 * Construct a new 'hidden' resource using the produced A with a nested lifetime
 * Useful for performing initialization and cleanup that clients don't need to see
 * @param left
 * @param bind
 */
function chainTap(left, bind) {
    return chain_(left, function (a) { return as(bind(a), a); });
}
exports.chainTap = chainTap;
/**
 * Curried form of chainTap
 * @param bind
 */
function chainTapWith(bind) {
    return function (inner) { return chainTap(inner, bind); };
}
exports.chainTapWith = chainTapWith;
/**
 * Curried data last form of use
 * @param f
 */
function consume(f) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return function (r) { return use(r, f); };
}
exports.consume = consume;
/**
 * Create a Resource from the fiber of an IO.
 * The acquisition of this resource corresponds to forking rio into a fiber.
 * The destruction of the resource is interrupting said fiber.
 * @param rio
 */
function fiber(rio) {
    return bracket(T.fork(rio), function (fiber) { return fiber.interrupt; });
}
exports.fiber = fiber;
/**
 * Use a resource to produce a program that can be run.s
 * @param res
 * @param f
 */
function use(res, f) {
    return T.accessM(function (r) {
        var c = fromM(res)(r);
        switch (c._tag) {
            case ManagedTag.Pure:
                return f(c.value);
            case ManagedTag.Encase:
                return T.effect.chain(c.acquire, f);
            case ManagedTag.Bracket:
                return T.bracket(c.acquire, c.release, f);
            case ManagedTag.BracketExit:
                return T.bracketExit(c.acquire, function (a, e) { return c.release(a, e); }, f);
            case ManagedTag.Suspended:
                return T.effect.chain(c.suspended, consume(f));
            case ManagedTag.Chain:
                return use(c.left, function (a) { return use(c.bind(a), f); });
        }
    });
}
exports.use = use;
/**
 * Create an IO action that will produce the resource for this managed along with its finalizer
 * action seperately.
 *
 * If an error occurs during allocation then any allocated resources should be cleaned up, but once the
 * Leak object is produced it is the callers responsibility to ensure release is invoked.
 * @param res
 */
function allocate(res) {
    return T.accessM(function (r) {
        var c = fromM(res)(r);
        switch (c._tag) {
            case ManagedTag.Pure:
                return T.pure({ a: c.value, release: T.unit });
            case ManagedTag.Encase:
                return T.effect.map(c.acquire, function (a) { return ({ a: a, release: T.unit }); });
            case ManagedTag.Bracket:
                return T.effect.map(c.acquire, function (a) { return ({ a: a, release: c.release(a) }); });
            case ManagedTag.BracketExit:
                // best effort, because we cannot know what the exit status here
                return T.effect.map(c.acquire, function (a) { return ({
                    a: a,
                    release: c.release(a, exit_1.done(undefined))
                }); });
            case ManagedTag.Suspended:
                return T.effect.chain(c.suspended, allocate);
            case ManagedTag.Chain:
                return T.bracketExit(allocate(c.left), function (leak, exit) { return (exit._tag === "Done" ? T.unit : leak.release); }, function (leak) {
                    return T.effect.map(allocate(c.bind(leak.a)), 
                    // Combine the finalizer actions of the outer and inner resource
                    function (innerLeak) { return ({
                        a: innerLeak.a,
                        release: T.effect.onComplete(innerLeak.release, leak.release)
                    }); });
                });
        }
    });
}
exports.allocate = allocate;
/**
 * Use a resource to provide part of the environment to an effect
 * @param man
 * @param ma
 */
function provide(man, inverted) {
    if (inverted === void 0) { inverted = "regular"; }
    return function (ma) { return use(man, function (r) { return T.provide(r, inverted)(ma); }); };
}
exports.provide = provide;
exports.URI = "matechs/Managed";
exports.managed = {
    URI: exports.URI,
    of: pure,
    map: map_,
    ap: ap_,
    chain: chain_
};
function getSemigroup(Semigroup) {
    return {
        concat: function (x, y) {
            return zipWith(x, y, Semigroup.concat);
        }
    };
}
exports.getSemigroup = getSemigroup;
function getMonoid(Monoid) {
    return __assign(__assign({}, getSemigroup(Monoid)), { empty: pure(Monoid.empty) });
}
exports.getMonoid = getMonoid;
function provideAll(r) {
    return function (ma) {
        return toM(function () { return fromM(ma)(r); });
    };
}
exports.Do = function () { return Do_1.Do(exports.managed); };
exports.sequenceS = Apply_1.sequenceS(exports.managed);
exports.sequenceT = Apply_1.sequenceT(exports.managed);
exports.sequenceOption = Op.option.sequence(exports.managed);
exports.traverseOption = function (f) { return function (ta) {
    return Op.option.traverse(exports.managed)(ta, f);
}; };
exports.wiltOption = function (f) { return function (wa) {
    return Op.option.wilt(exports.managed)(wa, f);
}; };
exports.witherOption = function (f) { return function (ta) {
    return Op.option.wither(exports.managed)(ta, f);
}; };
exports.sequenceEither = Ei.either.sequence(exports.managed);
exports.traverseEither = function (f) { return function (ta) {
    return Ei.either.traverse(exports.managed)(ta, f);
}; };
exports.sequenceTree = TR.tree.sequence(exports.managed);
exports.traverseTree = function (f) { return function (ta) {
    return TR.tree.traverse(exports.managed)(ta, f);
}; };
exports.sequenceArray = Ar.array.sequence(exports.managed);
exports.traverseArray = function (f) { return function (ta) {
    return Ar.array.traverse(exports.managed)(ta, f);
}; };
exports.traverseArrayWithIndex = function (f) { return function (ta) {
    return Ar.array.traverseWithIndex(exports.managed)(ta, f);
}; };
exports.wiltArray = function (f) { return function (wa) {
    return Ar.array.wilt(exports.managed)(wa, f);
}; };
exports.witherArray = function (f) { return function (ta) { return Ar.array.wither(exports.managed)(ta, f); }; };
exports.sequenceRecord = RE.record.sequence(exports.managed);
exports.traverseRecord = function (f) { return function (ta) {
    return RE.record.traverse(exports.managed)(ta, f);
}; };
exports.traverseRecordWithIndex = function (f) { return function (ta) {
    return RE.record.traverseWithIndex(exports.managed)(ta, f);
}; };
exports.wiltRecord = function (f) { return function (wa) {
    return RE.record.wilt(exports.managed)(wa, f);
}; };
exports.witherRecord = function (f) { return function (ta) {
    return RE.record.wither(exports.managed)(ta, f);
}; };
